import { Schema as S } from "effect";

export const GetCardsRequestSchema = S.Struct({
  terminalId: S.String,
});

export type GetCardsRequest = S.Schema.Type<typeof GetCardsRequestSchema>;
